/**
 * 뒤로가기 스크롤 위치 복원 적용 path
 * @type {string[]}
 */
const availableBackScrollPath = [
  '/ds/diy',
  '/ds/diy2',
  '/ds/dst/SCR_DST_0015',
  '/ds/new/',
  '/ds/newShorts/',
  '/ds/rank',
  '/ds/exbt',
  '/ds/spexhbt',
  '/ds/exhCtgr',
  '/ds/spexhbt',
  '/ds/bulkOrder',
  '/ds/quickOrder',
  '/ds/pickupOrder',
  '/ev/evc/SCR_EVC_0001',
  '/ds/orderGate',
  '/ds/rate',
  '/ds/soldOut',
  '/ds/curation/interest',
  '/ds/curation/purchase',
  '/ds/curation/total',
  '/ev/tutorial'
]

/**
 * keep-alive 적용 components
 * @type {string[]}
 */
const useKeepAliveComponents = [
  'DsIndex',
  'DIY',
  'DIY2',
  'ExbtListPage',
  'ExbtDetailPage',
  'EVC0001',
  'RATE',
  'SOLDOUT',
  'NewShorts',
  'Curation',
  'ExhCtgr',
  'SCRPDM0002',
]

/**
 * mounted 이전에 화면 미노출 적용 path
 * 페이지 별 mounted 시 this.$nuxt.$emit('page-mounted') 실행 시켜야 함
 * @type {string[]}
 */
const checkMountedPath = [
  'SCR_PDR_0001',
  '/ds/diy',
  '/ds/diy2',
  '/ds/dst/SCR_DST_0015',
  '/ds/exbt',
  '/ds/spexhbt',
  '/ds/new/',
  '/ds/rank',
  '/ds/bulkOrder',
  '/ds/quickOrder',
  '/ds/pickupOrder',
  '/ev/evc/SCR_EVC_0001',
  '/ds/orderGate',
  '/ds/rate',
  '/ds/soldOut'
]

export {
  availableBackScrollPath,
  checkMountedPath,
  useKeepAliveComponents
}
